import React from 'react';
import {Link, browserHistory} from 'react-router';
import {ContainerFileDinhKem} from 'components/upload';
import { msg } from 'constants/message';
import { connect } from 'react-redux';
import { API_URL } from 'constants/config';
import { Dialog } from "@blueprintjs/core";
import { getParams } from 'modules/giai-quyet-don/subView/GetParams.jsx';
import {
  DropDownChonKetLuanNoiDungKhieuNai,
  DropDownChonKetQuaThucHien,
  DropDownKetQuaGiaiQuyetDon,
  DropDownChonCoQuanDieuTra,
  DropDownMulipleUse,
  DropDownNguoiKy
} from 'components/tt-forms';
import moment from 'moment';
import { GiaiQuyetDonThu, DuLieuHeThong } from 'api';
import { ShowIf, ShowIfCheck } from 'components/utils';
import {TextArea, DatePicker, Input, InputNumber, TextMessage, Text} from 'components/tt-forms/common';
import ConfirmDialog from './ConfirmDialog.jsx';
import { Toastr } from 'modules/toastr';

const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'GIAI_QUYET_DON';

class GiaiQuyetDonCanBo extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      id: this.props.donId,
      btnLoading: false,
      btnSaveLoading: false,
      openDialogGiaoTTXM: false,
      openDialogLuuHoSo: false,
      isValid: false,
      loaiDon: this.props.loaiDonGiaTri,
      gqText: (this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') ? 'Ban hành văn bản giải quyết' : ((this.props.loaiDonGiaTri == 'DON_TO_CAO') ? 'Ban hành kết luận nội dung tố cáo' : 'Ban hành quyết định giải quyết'),
      tTXMRequired: false,
      open: false,
      showFile: false,

      lapToDoanXacMinh: false,
      giaHanGiaiQuyet: false,
      giaHanTTXM: false,
      doiThoai: false,
      giaoCoQuanDieuTra: false,
      quyetDinhGiaiQuyetKhieuNai: false,
      theoDoiThucHien: false,
      khoiTo: false,
      showTienDoGiaiQuyet: false,

      valueKetQua: '',

      donViThamTraXacMinh: '',
      ngayHetHanGiaiQuyet: '',
      ngayHetHanTTXM: '',

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        baoCaoKetQuaTTXM: [],
        quyetDinhGiaiQuyet: [],
        giaoCoQuanDieuTra: [],
        giaHan: [],
        data: []
      },
      dataTaiLieuVanThuDelete: [],
      taiLieuVanThuGiaoCoQuanDieuTra: [],
      dataCoQuanTheoDoi: [],
      nextState: '',
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,

      soQuyetDinhThanhLapDTXM: '',
      truongDoanTTXM: '',

      ketLuanNoiDungKhieuNai: '',
      ketLuanNoiDungKhieuNaiGiaoTTXM: '',

      //DON_KHIEU_NAI
      soQuyetDinhGiaHanTTXM: '',
      ngayRaQuyetDinhGiaHanTTXM: '',
      ngayHetHanSauKhiGiaHanTTXM: '',
      lyDoGiaHanGia: '',

      //DON_TO_CAO
      soQuyetDinhGiaHanGiaiQuyet: '',
      ngayRaQuyetDinhGiaHanGiaiQuyet: '',
      ngayHetHanSauKhiGiaHanGiaiQuyet: '',
      lyDoGiaHanGiaiQuyet: '',

      thoiGianDoiThoai: '',
      diaDiemDoiThoai: '',

      coQuanDieuTra: '',
      soVuGiaoCoQuanDieuTra: '',
      soDoiTuongGiaoCoQuanDieuTra: '',

      tienPhaiThuNhaNuoc: '',
      datPhaiThuNhaNuoc: '',
      tienPhaiTraCongDan: '',
      datPhaiTraCongDan: '',
      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',

      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',

      soVuBiKhoiTo: '',
      soDoiTuongBiKhoiTo: '',

      soVuGiaiQuyetKhieuNai: '',

      tienDaThuNhaNuoc: '',
      datDaThuNhaNuoc: '',
      tienDaTraCongDan: '',
      datDaTraCongDan: '',

      yKienGiaiQuyet: '',

      tienPhaiThuNhaNuocQDGQ: '',
      tienPhaiTraCongDanQDGQ: '',
      datPhaiThuNhaNuocQDGQ: '',
      datPhaiTraCongDanQDGQ: '',
      soNguoiDuocTraLaiQuyenLoi: '',

      soLanGiaiQuyetLai: '',
      ketQuaThucHienKhac: '',
      ketQuaKhac: '',
      ketQuaGiaiQuyetLan2: '',
      noiDungKetLuanGiaiQuyetLai: '',
      listTaiLieuVanThuGiaiQuyetDonView: this.props.listTaiLieuVanThuGiaiQuyetDonView,

      allowAttach: false,
      allowAttachGiaoCoQuanDieuTra: false,
      hasChange: false,
      backConfirm: false,
      thoiHanBaoCaoKetQuaTTXM:'',
      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: '',
      dataKetQuaGiaiQuyetDon: [],
      tienDoDoiThoai: '',
      message: 'Chọn "'+ this.gqText +'" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?',
      lyDoBanHanhQuyetDinhDinhChi: '',
      lyDoBanHanhQuyetDinhGiaiQuyet: '',
      tenCoQuan: this.props.tenCoQuan
    }
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    this.getCoQuanTheoDoiEnumn();
    this.getKetQuaGiaiQuyetDon();
    if (window.debug) {
      console.log('handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/GiaiQuyetDonCanBo');
    }
    if(this.props.tenCoQuan.length == 0) {
      DuLieuHeThong.actions.getDonViTTXM.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'donViTTXM',
            data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.tenCoQuan != this.props.tenCoQuan) {
      this.state.tenCoQuan = nextProps.tenCoQuan;
      this.setState({...this.state})
    }
  }

  getKetQuaGiaiQuyetDon() {
    let params = {
      banHanhQuyetDinh: true,
      khongCoDoiThoai: false,
      loaiDon: this.props.loaiDonGiaTri
    }
    GiaiQuyetDonThu.actions.getKetQuaGiaiQuyetDon.request(params).then(res => {
      if (res.data) {
        this.setState({
          dataKetQuaGiaiQuyetDon: res.data
        })
      }
    })
  }

  getCoQuanTheoDoiEnumn() {
    GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(res => {
      if (res.data) {
        this.setState({
          dataCoQuanTheoDoi: res.data
        })
      }
    })
  }

  checkTypeComponent() {
    this.setState({
      nextState: 'KET_THUC',
      tTXMRequired: true
    });
  }

  onClickClose(type) {
    if (type == true) {
      browserHistory.goBack()
    } else if (this.state.hasChange) {
      this.setState({
        backConfirm: true
      })
    } else {
      browserHistory.goBack()
    }
  }

  closeConfirmBack() {
    this.setState({
      backConfirm: false
    })
  }

  hasChange() {
    this.setState({
      hasChange: true
    })
  }

  getThongTinGiaiQuyetDon(id) {
    if(typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
      let params = {
        id: id
      };
      GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(res => {
        if(res.data) {
          this.setState({
            dataGiaiQuyetDon: res.data,
            soQuyetDinhThanhLapDTXM: res.data.soQuyetDinhThanhLapDTXM,
            truongDoanTTXM: res.data.truongDoanTTXMInfo ? res.data.truongDoanTTXMInfo.congChucId : '',

            ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : '',
            ketLuanNoiDungKhieuNaiGiaoTTXM: res.data.ketLuanNoiDungKhieuNaiGiaoTTXM ? res.data.ketLuanNoiDungKhieuNaiGiaoTTXM : '',

            giaHanTTXM : res.data.giaHanTTXM,
            soQuyetDinhGiaHanTTXM : res.data.soQuyetDinhGiaHanTTXM ? res.data.soQuyetDinhGiaHanTTXM : '',
            ngayRaQuyetDinhGiaHanTTXM : res.data.ngayRaQuyetDinhGiaHanTTXM ? new Date(res.data.ngayRaQuyetDinhGiaHanTTXM) : '',
            ngayHetHanSauKhiGiaHanTTXM : res.data.ngayHetHanSauKhiGiaHanTTXM  ? new Date(res.data.ngayHetHanSauKhiGiaHanTTXM ) : '',
            lyDoGiaHanTTXM : res.data.lyDoGiaHanTTXM ? res.data.lyDoGiaHanTTXM : '',

            giaHanGiaiQuyet : res.data.giaHanGiaiQuyet,
            soQuyetDinhGiaHanGiaiQuyet : res.data.soQuyetDinhGiaHanGiaiQuyet ? res.data.soQuyetDinhGiaHanGiaiQuyet : '',
            ngayRaQuyetDinhGiaHanGiaiQuyet : res.data.ngayRaQuyetDinhGiaHanGiaiQuyet ? new Date(res.data.ngayRaQuyetDinhGiaHanGiaiQuyet) : '',
            ngayHetHanGiaiQuyet : res.data.ngayHetHanGiaiQuyet ? new Date(res.data.ngayHetHanGiaiQuyet) : '',
            ngayHetHanSauKhiGiaHanGiaiQuyet : res.data.ngayHetHanSauKhiGiaHanGiaiQuyet ? new Date(res.data.ngayHetHanSauKhiGiaHanGiaiQuyet) : '',
            lyDoGiaHanGiaiQuyet : res.data.lyDoGiaHanGiaiQuyet ? res.data.lyDoGiaHanGiaiQuyet : '',

            thoiGianDoiThoai: res.data.thoiGianDoiThoai ? new Date(res.data.thoiGianDoiThoai) : '',
            noiDungDoiThoai: res.data.noiDungDoiThoai ? res.data.noiDungDoiThoai : '',
            diaDiemDoiThoai: res.data.diaDiemDoiThoai,

            soVanBan: res.data.soVanBan ? res.data.soVanBan : '',
            ngayBanHanh: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
            nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',

            coQuanDieuTra: res.data.coQuanDieuTraInfo ? res.data.coQuanDieuTraInfo.coQuanQuanLyId : '',
            soVuGiaoCoQuanDieuTra: res.data.soVuGiaoCoQuanDieuTra,
            soDoiTuongGiaoCoQuanDieuTra: res.data.soDoiTuongGiaoCoQuanDieuTra,

            tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
            datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
            tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
            datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
            tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
            soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,

            hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
            coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
            ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',

            khoiTo: res.data.khoiTo,
            soVuBiKhoiTo: res.data.soVuBiKhoiTo,
            soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,

            soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,

            tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
            datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
            tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
            datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,

            lapToDoanXacMinh: res.data.lapToDoanXacMinh,
            doiThoai: res.data.doiThoai,
            giaoCoQuanDieuTra: res.data.giaoCoQuanDieuTra,
            quyetDinhGiaiQuyetKhieuNai: res.data.quyetDinhGiaiQuyetKhieuNai,
            theoDoiThucHien: res.data.theoDoiThucHien,
            lyDoBanHanhQuyetDinhGiaiQuyet: res.data.lyDoBanHanhQuyetDinhGiaiQuyet || '',
            lyDoBanHanhQuyetDinhDinhChi: res.data.lyDoBanHanhQuyetDinhDinhChi || '',

            donViThamTraXacMinh: res.data.donViThamTraXacMinhInfo ? res.data.donViThamTraXacMinhInfo.coQuanQuanLyId : '',
            ngayHetHanTTXM: res.data.ngayHetHanTTXM ? new Date(res.data.ngayHetHanTTXM) : '',
            yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',

            tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
            tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
            datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
            datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
            soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,
            ketQuaXLDGiaiQuyet: (res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') ? res.data.ketQuaXLDGiaiQuyet : '',
            tienDoDoiThoai: res.data.ketQuaXLDGiaiQuyet ? (res.data.ketQuaXLDGiaiQuyet == 'DOI_THOAI' ? 'DOI_THOAI' : 'KHONG_DOI_THOAI') : (this.props.loaiDon != 'DON_KHIEU_NAI' ? 'KHONG_DOI_THOAI' : ''),
            showTienDoGiaiQuyet: (res.data.ketQuaXLDGiaiQuyet && (res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) ? true : false,
            soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,

            ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
            ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
            ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
            noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',
            showFile: true,
            allowAttach: true
          }, () => {
            this.checkFileCoQuanDieuTra();
          })
        }
        this.checkTypeComponent();
      });
    }
  }

  checkFileCoQuanDieuTra() {
    this.setState({
      allowAttachGiaoCoQuanDieuTra: false
    }, () => {
      if (this.state.giaoCoQuanDieuTra == false) {
        this.setState({
          allowAttachGiaoCoQuanDieuTra: true
        })
      } else {
        let taiLieuVanThuGiaoCoQuanDieuTra = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
        let data = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
        let dataCheck = data.filter(state => {
          return state.required && state.typeRequired === 'GIAO_CO_QUAN_DIEU_TRA'
        });

        if (dataCheck.length > 0) {
          this.setState({
            taiLieuVanThuGiaoCoQuanDieuTra: taiLieuVanThuGiaoCoQuanDieuTra,
            allowAttachGiaoCoQuanDieuTra: true
          })
        } else {
          let newItem = {
            ten: 'Văn bản về việc chuyển hồ sơ sang cơ quan điều tra',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'GIAO_CO_QUAN_DIEU_TRA',
            newFile: true
          }
          this.setState({
            taiLieuVanThuGiaoCoQuanDieuTra: [
              ...taiLieuVanThuGiaoCoQuanDieuTra,
              newItem
            ],
            allowAttachGiaoCoQuanDieuTra: true
          })
        }
      }
    })
  }

  handleChangeDate(name, e) {
    this.hasChange();
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  onChange(name, e) {
    this.hasChange();
    if (name === 'ketQuaXLDGiaiQuyet' && e.target.value === 'DA_CO_QUYET_DINH_GIAI_QUYET') {
      this.state.message = `Chọn "${this.state.gqText}" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?`;
      this.state.open = true;
      this.state.valueKetQua = e.target.value;
      this.setState({
        ...this.state
      })
    } else if (name === 'ketQuaXLDGiaiQuyet' && e.target.value === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
      this.state.message = 'Chọn "Ban hành quyết định đình chỉ" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?';
      this.state.open = true;
      this.state.valueKetQua = e.target.value;
      this.setState({
        ...this.state
      })
    } else {

      this.setState({
        [name]: e.target.value
      });

      if (name === 'tienDoDoiThoai' && e.target.value != 'KHONG_DOI_THOAI') {
        this.state.ketQuaXLDGiaiQuyet = '';
        this.state.tienDoDoiThoai = e.target.value;
        this.setState({
          ...this.state
        })
      }

      if (name === 'ketQuaXLDGiaiQuyet' || name === 'nextState' || name === 'hinhThucTheoDoi' || name === 'soLanGiaiQuyetLai' || name === 'ketQuaGiaiQuyetLan2') {

      }

      if (name === 'soLanGiaiQuyetLai' && Number(e.target.value) <= 1) {
        this.setState({
          ketQuaGiaiQuyetLan2: ''
        })
      }

      if (name === 'ketQuaGiaiQuyetLan2' && Number(e.target.value) != 'HUY_SUA_QDGQ_LAN_I') {
        this.setState({
          noiDungKetLuanGiaiQuyetLai: ''
        })
      }

      if (name === 'nextState' && e.target.value === 'CAN_BO_CHUYEN_DON_VI_TTXM') {
        this.setState({
          tTXMRequired: false
        })
      }
    }
  }

  sheckFileRequired(data) {
    this.setState({
      showFile: false
    })
    let listTaiLieuVanThuGiaiQuyetDonView = [...this.state.listTaiLieuVanThuGiaiQuyetDonView];

    let dataCheckFileRequired = listTaiLieuVanThuGiaiQuyetDonView.filter(state => {
      return state.required && state.typeRequired === 'QD_GTTXM'
    })

    if (dataCheckFileRequired.length > 0) {
      // do nothing
      this.setState({
        nextState: data ? data : this.state.nextState,
        showFile: true
      })

    } else {
      let fileRequired = {
        loaiTepDinhKem: '',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        duongDan: '',
        progress: 0,
        required: true,
        typeRequired: 'QD_GTTXM'
      }
      if (this.state.loaiDon === 'DON_KHIEU_NAI') {
        fileRequired.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung khiếu nại'
      } else if(this.state.loaiDon === 'DON_TO_CAO') {
        fileRequired.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung tố cáo'
      } else {
        fileRequired.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung kiến nghị phản ánh'
      }
      this.setState({
        listTaiLieuVanThuGiaiQuyetDonView: [...this.state.listTaiLieuVanThuGiaiQuyetDonView,
          fileRequired
        ],
        nextState: data ? data : this.state.nextState,
        showFile: true
      });

    }
  }

  onFileChange(data, type) {
    this.hasChange();
    let dataFileDinhKem = {...this.state.dataFileDinhKem};
    if (type === 'BAO_CAO_KET_QUA_TTXM') {
      dataFileDinhKem.baoCaoKetQuaTTXM = data;
    } else if (type === 'QUYET_DINH_GIAI_QUYET') {
      dataFileDinhKem.quyetDinhGiaiQuyet = data;
      let fileQD = data.filter(item => {
        return item.typeRequired == 'QDGQ_TTT'
      });
      this.setState ({ngayBanHanh: fileQD.length ? fileQD[0].ngayQuyetDinh : ''});
    } else if (type === 'GIAO_CO_QUAN_DIEU_TRA') {
      dataFileDinhKem.giaoCoQuanDieuTra = data;
    } else if (type === 'GIA_HAN') {
      dataFileDinhKem.giaHan = data;
    } else {
      dataFileDinhKem.data = data;
    }
    this.setState ({
      dataFileDinhKem: dataFileDinhKem
    });
  }

  getListDataFileDinhKem(type) {
    if (type === 'GIAO_TTXM') {
      return this.state.dataFileDinhKem.data;
    } else {
      let dataFileDinhKem = []
      let Data = this.state.dataFileDinhKem;

      if (Data.baoCaoKetQuaTTXM.length > 0) {
        Data.baoCaoKetQuaTTXM.map(state => {
          dataFileDinhKem[dataFileDinhKem.length] = state
        })
      }

      if (Data.data.length > 0) {
        Data.data.map(state => {
          dataFileDinhKem[dataFileDinhKem.length] = state
        })
      }

      if (Data.quyetDinhGiaiQuyet.length > 0 && (this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) {
        Data.quyetDinhGiaiQuyet.map(state => {
          dataFileDinhKem[dataFileDinhKem.length] = state
        })
      }

      if (Data.giaoCoQuanDieuTra.length > 0 && this.state.giaoCoQuanDieuTra) {
        Data.giaoCoQuanDieuTra.map(state => {
          dataFileDinhKem[dataFileDinhKem.length] = state
        })
      }

      if (Data.giaHan.length > 0 && (this.state.giaHanGiaiQuyet)) {
        Data.giaHan.map(state => {
          dataFileDinhKem[dataFileDinhKem.length] = state
        })
      }

      return dataFileDinhKem;
    }
  }

  getParams() {
    let dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
    let params = getParams(dataGiaiQuyetDon, this.state.id);
    if(this.state.giaoCoQuanDieuTra) {
      params.giaoCoQuanDieuTra = true;
      if (this.state.coQuanDieuTra) {
        params.coQuanDieuTra =  {
          id: Number(this.state.coQuanDieuTra)
        }
      }
      params.soVuGiaoCoQuanDieuTra = Number(this.state.soVuGiaoCoQuanDieuTra);
      params.soDoiTuongGiaoCoQuanDieuTra = Number(this.state.soDoiTuongGiaoCoQuanDieuTra);
      if(this.state.khoiTo) {
        params.khoiTo = true;
        params.soVuBiKhoiTo = Number(this.state.soVuBiKhoiTo);
        params.soDoiTuongBiKhoiTo = Number(this.state.soDoiTuongBiKhoiTo);
      } else {
        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
      }
    } else {
      params.giaoCoQuanDieuTra = false;
      params.coQuanDieuTra =  null
      params.soVuGiaoCoQuanDieuTra = 0;
      params.soDoiTuongGiaoCoQuanDieuTra = 0;
      params.khoiTo = false;
      params.soVuBiKhoiTo = 0;
      params.soDoiTuongBiKhoiTo = 0;
    }
    if(this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET') {
      params.quyetDinhGiaiQuyetKhieuNai = true;
      params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;

      params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
      params.ngayBanHanh = this.state.ngayBanHanh ? moment(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
      params.nguoiBanHanh = this.state.nguoiBanHanh ? {id: this.state.nguoiBanHanh} : null;
      params.lyDoBanHanhQuyetDinhGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;

      if (this.props.loaiDon === 'DON_KHIEU_NAI') {
        params.soLanGiaiQuyetLai = Number(this.state.soLanGiaiQuyetLai);

        if (Number(this.state.soLanGiaiQuyetLai) > 1) {
          params.ketQuaGiaiQuyetLan2 = this.state.ketQuaGiaiQuyetLan2 ? this.state.ketQuaGiaiQuyetLan2 : null;
        } else {
          params.ketQuaGiaiQuyetLan2 = null;
        }

        if ((this.state.ketQuaGiaiQuyetLan2 === 'HUY_SUA_QDGQ_LAN_I') && (Number(this.state.soLanGiaiQuyetLai) > 1)) {
          params.noiDungKetLuanGiaiQuyetLai = this.state.noiDungKetLuanGiaiQuyetLai;
        } else {
          params.noiDungKetLuanGiaiQuyetLai = '';
        }
      }

      params.tienPhaiThuNhaNuocQDGQ = Number(this.state.tienPhaiThuNhaNuocQDGQ);
      params.tienPhaiTraCongDanQDGQ = Number(this.state.tienPhaiTraCongDanQDGQ);
      params.datPhaiThuNhaNuocQDGQ = Number(this.state.datPhaiThuNhaNuocQDGQ);
      params.datPhaiTraCongDanQDGQ = Number(this.state.datPhaiTraCongDanQDGQ);

      params.soVuGiaiQuyetKhieuNai = Number(this.state.soVuGiaiQuyetKhieuNai);
      params.ketLuanNoiDungKhieuNai = this.state.ketLuanNoiDungKhieuNai ? this.state.ketLuanNoiDungKhieuNai : null;
      params.tongSoNguoiXuLyHanhChinh = Number(this.state.tongSoNguoiXuLyHanhChinh);
      params.soNguoiDaBiXuLyHanhChinh = Number(this.state.soNguoiDaBiXuLyHanhChinh);
      params.soNguoiDuocTraLaiQuyenLoi = Number(this.state.soNguoiDuocTraLaiQuyenLoi);
    } else {
      params.quyetDinhGiaiQuyetKhieuNai = false;

      params.soLanGiaiQuyetLai = 0;
      params.ketQuaGiaiQuyetKhac = '';

      params.ketQuaGiaiQuyetLan2 = null;
      params.noiDungKetLuanGiaiQuyetLai = '';

      params.tienPhaiThuNhaNuocQDGQ = 0;
      params.tienPhaiTraCongDanQDGQ = 0;
      params.datPhaiThuNhaNuocQDGQ = 0;
      params.datPhaiTraCongDanQDGQ = 0;

      params.soVuGiaiQuyetKhieuNai = 0;
      params.ketLuanNoiDungKhieuNai = null;
      params.tongSoNguoiXuLyHanhChinh = 0;
      params.soNguoiDaBiXuLyHanhChinh = 0;

      params.soNguoiDuocTraLaiQuyenLoi = 0;
    }

    if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
      params.lyDoBanHanhQuyetDinhDinhChi = this.state.lyDoBanHanhQuyetDinhDinhChi;
      params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
      params.ngayBanHanh = this.state.ngayBanHanh ? moment(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
      params.nguoiBanHanh = this.state.nguoiBanHanh ? {id: this.state.nguoiBanHanh} : null;
    }

    if(this.state.theoDoiThucHien) {
      params.theoDoiThucHien = true;
      params.hinhThucTheoDoi = this.state.hinhThucTheoDoi;
      if (this.state.coQuanTheoDoi && this.state.hinhThucTheoDoi === 'GIAO_CO_QUAN_KHAC_THEO_DOI') {
        params.coQuanTheoDoi = this.state.coQuanTheoDoi
      } else {
        params.coQuanTheoDoi = null
      }
      params.ketQuaThucHienTheoDoi = this.state.ketQuaThucHienTheoDoi;
      params.ketQuaThucHienKhac = this.state.ketQuaThucHienKhac;

      params.tienPhaiThuNhaNuoc = Number(this.state.tienPhaiThuNhaNuoc);
      params.datPhaiThuNhaNuoc = Number(this.state.datPhaiThuNhaNuoc);
      params.tienPhaiTraCongDan = Number(this.state.tienPhaiTraCongDan);
      params.datPhaiTraCongDan = Number(this.state.datPhaiTraCongDan);

      params.tienDaThuNhaNuoc = Number(this.state.tienDaThuNhaNuoc);
      params.datDaThuNhaNuoc = Number(this.state.datDaThuNhaNuoc);
      params.tienDaTraCongDan = Number(this.state.tienDaTraCongDan);
      params.datDaTraCongDan = Number(this.state.datDaTraCongDan);
    } else {
      params.theoDoiThucHien = false;
      params.ketQuaThucHienKhac = '';
      params.hinhThucTheoDoi = null;
      params.coQuanTheoDoi = null
      params.ketQuaThucHienTheoDoi = null;

      params.tienDaThuNhaNuoc = 0;
      params.datDaThuNhaNuoc = 0;
      params.tienDaTraCongDan = 0;
      params.datDaTraCongDan = 0;

      params.tienPhaiThuNhaNuoc = 0;
      params.datPhaiThuNhaNuoc = 0;
      params.tienPhaiTraCongDan = 0;
      params.datPhaiTraCongDan = 0;
    }

    params.ketQuaXLDGiaiQuyet = (this.state.tienDoDoiThoai == 'KHONG_DOI_THOAI' && this.state.ketQuaXLDGiaiQuyet) ? this.state.ketQuaXLDGiaiQuyet :  null;

    if (this.state.loaiDon === 'DON_KHIEU_NAI' || this.state.loaiDon === 'DON_TO_CAO') {
      if(this.state.doiThoai) {
        params.doiThoai = true;
        params.thoiGianDoiThoai = moment(this.state.thoiGianDoiThoai).add(7, 'hours').toISOString();
        params.diaDiemDoiThoai = this.state.diaDiemDoiThoai;
        params.noiDungDoiThoai = this.state.noiDungDoiThoai;
      } else {
        params.doiThoai = false;
        params.thoiGianDoiThoai = null;
        params.diaDiemDoiThoai = '';
        params.noiDungDoiThoai = '';
      }
    } else {
      params.doiThoai = false;
      params.thoiGianDoiThoai = null;
      params.diaDiemDoiThoai = '';
      params.noiDungDoiThoai = '';
    }

    params.donViThamTraXacMinh = null;
    params.ngayHetHanTTXM = null;
    params.yKienGiaiQuyet = '';

    params.ketLuanNoiDungKhieuNaiGiaoTTXM = this.state.ketLuanNoiDungKhieuNaiGiaoTTXM ? this.state.ketLuanNoiDungKhieuNaiGiaoTTXM : null;

    return params;
  }

  handleSave() {
    this.setState({
      onSave: true
    }, () => {

      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });

      let dataFileDinhKem = this.getListDataFileDinhKem('KET_THUC');

      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map((item, i) => {
          if (item.taiLieuVanThuId) {
            this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(this.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
              don: {
                id: Number(this.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });
      }

      if (this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' ) {
        let dataFile = [...this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ]
        dataFile.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item.taiLieuVanThuId
          };
        });
      }

      if (!this.state.giaoCoQuanDieuTra) {
        let dataFile = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra]
        dataFile.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item.taiLieuVanThuId
          };
        });
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      let params = this.getParams();
      this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
        this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
          this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
            this.saveGiaiQuyetDon(params, 'gqdLuu');
          });
        });
      });
    })
  }

  handleKetThuc() {
    this.setState({
      onSave: false
    },()=> {
      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true
        });
        let dataFileDinhKem = this.getListDataFileDinhKem('KET_THUC');

        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map((item, i) => {
            if (item.taiLieuVanThuId) {
              this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(this.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(this.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });
        }

        if (this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' ) {
          let dataFile = [...this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ]
          dataFile.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (!this.state.giaoCoQuanDieuTra) {
          let dataFile = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra]
          dataFile.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        let _params = this.getParams();
        let selectedState = this.props.listNextStates.filter(state => {
          return state.type == this.state.nextState
        });

        let params = {
          thongTinGiaiQuyetDon: {
            id: Number(this.state.thongTinGiaiQuyetDonId)
          },
          nextState: {
            id: Number(selectedState[0].stateId)
          }
        }
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.updateGiaiQuyetDon(_params, params, 'gqdLuuHoSo');
            });
          });
        });
      }
    })
  }

  handleCheck(name, e) {
    this.hasChange();
    this.setState({
      [name]: e
    });
    if (name =='giaoCoQuanDieuTra') {
      this.checkFileCoQuanDieuTra();
    }
    if (!e) {

    }
  }

   // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {
        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {
        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {
        }
        callback();
      });
    } else {
      callback();
    }
  }

  onFileRemove(id, data, type) {
    this.hasChange();
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });
    if (type === 'BAO_CAO_KET_QUA_TTXM') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.baoCaoKetQuaTTXM = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type === 'QUYET_DINH_GIAI_QUYET') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.quyetDinhGiaiQuyet = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type === 'GIAO_CO_QUAN_DIEU_TRA') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaoCoQuanDieuTra = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type === 'GIA_HAN') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaHan = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.data = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    }


  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    })
    return pass;
  }

  componentWillUnmount() {

  }

  inPhieuGiaoTTXMKhieuNai() {
    let tenCoQuan = this.state.tenCoQuan.filter(state => {
      return state.coQuanQuanLyId == this.state.donViThamTraXacMinh
    })
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
    let URL = String(API_URL) + "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhKhieuNai?"
    + "tenCoQuanThuLyGQKN=" + (this.props.coQuanDangQuyetInfo ? this.props.coQuanDangQuyetInfo.ten : '')
    + "&tenCoQuanDuocGiaoNhiemVuXM=" + (tenCoQuan.length > 0 ? tenCoQuan[0].ten : '')
    + "&hoTenNguoiKhieuNai=" + (this.props.listNguoiDungDon ? this.props.listNguoiDungDon[0].hoVaTen : '')
    + "&thoiGianBaoCaoKetQuaTTXM=" + moment(this.state.ngayHetHanTTXM).format('DD/MM/YYYY')
    + "&donViXuLyId=" + userInfo.donViId
    + "&noiDungTTXM=" + this.props.noiDungDonThu;
    window.open(URL, "_self");
  }

  inPhieuGiaoTTXMToCao() {
    let tenCoQuan = this.state.tenCoQuan.filter(state => {
      return state.coQuanQuanLyId == this.state.donViThamTraXacMinh
    })
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
    let URL = String(API_URL) + "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhToCao?"
    + "tenCoQuan=" + (tenCoQuan.length > 0 ? tenCoQuan[0].ten : '')
    + "&donViXuLyId=" + userInfo.donViId
    + "&thoiGianBaoCaoKetQuaTTXM=" + moment(this.state.ngayHetHanTTXM).format('DD/MM/YYYY')
    + "&noiDungDonThu=" + this.props.noiDungDonThu;
    window.open(URL, "_self");
  }

  openDialog(name) {
    if (this.validateSubmitForm()) {
      if (name === 'giaoTTXM') {
        this.setState({
          openDialogGiaoTTXM: true
        })
      } else {
        this.setState({
          openDialogLuuHoSo: true
        })
      }
    }
  }

  closeDialog() {
    this.setState({
      openDialogGiaoTTXM: false,
      openDialogLuuHoSo: false
    })
  }

  onSuccess(name) {
    this.setState({
      openDialogLuuHoSo: false
    });
    this.handleKetThuc();
  }

  closeDialogConfirm() {
    this.setState({
      open: false,
      ketQuaXLDGiaiQuyet: this.state.ketQuaXLDGiaiQuyet
    })
  }

  onSuccessDialogConfirm() {
    this.setState({
      open: false,
      ketQuaXLDGiaiQuyet: this.state.valueKetQua
    })
  }

  updateGiaiQuyetDon(params, _params, message) {
    GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({id: this.state.thongTinGiaiQuyetDonId},params).then(res => {
      this.postGiaiQuyetDon(_params, message);
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  saveGiaiQuyetDon(params, message) {
    GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({id: this.state.thongTinGiaiQuyetDonId},params).then(res => {
      this.onClickClose(true);
      Toastr(message ? msg[message] : msg.luuGiaiQuyetDonThanhCong, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postGiaiQuyetDon(params, message) {
    GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(res => {
      this.onClickClose(true);
      Toastr(message ? msg[message] : msg.giaiQuyetDon, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  render() {
    let ketQuaGiaiQuyetDon = this.state.dataKetQuaGiaiQuyetDon.filter(state => {
      return state.giaTri == this.state.ketQuaXLDGiaiQuyet
    })
    let lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
    return (
      <section className="wrap-block container-filedinhkem">
        <ConfirmDialog open={this.state.backConfirm}
          onClose={this.closeConfirmBack.bind(this)}
          onSuccess={this.onClickClose.bind(this, true)}
          title='Xác nhận'
          content={msg.confirmBack} />
        <div className="row pl10 pr10">
          <ShowIf condition={this.state.nextState === 'KET_THUC'}>
            <div className="col-100">
              <div className="col-100 no-gutter pt5 pb15">
                <span className="line-border"></span>
              </div>
              <div className="col-100 no-gutter">
                <h2 className="title-12 mb15">Báo cáo kết quả xác minh{lb2}</h2>
                <div className="col-100 no-gutter">
                  <div className="col-100 no-gutter pb5">
                    <ShowIf condition={this.state.allowAttach}>
                      <ContainerFileDinhKem onSave={this.state.onSave} loaiDon={this.props.loaiDon} phanLoaiQuyTrinh='BAO_CAO_KET_QUA_TTXM' label="Danh sách văn bản xử lý" tTXMText='TTXM_TTT' tTXMRequired={true} bindValidator={this} data={this.props.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                    </ShowIf>
                  </div>

                  <ShowIf condition={this.props.loaiDon === 'DON_TO_CAO' && this.state.giaHanGiaiQuyet}>
                    <div className="col-100 no-gutter mt5">
                      <div className="row pl10 pr10">
                        <div className="col-100 pb15">
                          <span className="line-border"></span>
                        </div>
                        <p className="txt-bold txt-upper mb10 pl5 pr5">Gia hạn giải quyết tố cáo</p>
                        <Text className="col-25 mb10" label="Gia hạn đến ngày:" value={this.state.ngayHetHanSauKhiGiaHanGiaiQuyet ? moment(this.state.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''}/>
                        <TextMessage className="col-100 mb5" label="Lý do gia hạn:" value={this.state.lyDoGiaHanGiaiQuyet}/>
                        <div className="col-100 pb5">
                          <ContainerFileDinhKem phanLoaiQuyTrinh='GIA_HAN' label="Danh sách văn bản xử lý" bindValidator={this} data={this.props.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} onSave={this.props.onSave}/>
                        </div>
                      </div>
                    </div>
                  </ShowIf>
                </div>
              </div>

              <ShowIf condition={this.state.nextState === 'KET_THUC'}>
                <div className="col-100 no-gutter">
                  <div className="col-100 no-gutter pt5 pb15">
                    <span className="line-border"></span>
                  </div>

                  <h2 className="title-12 mb10">Tiến độ giải quyết</h2>
                  <div className="row pl10 pr10">
                    <p className="attach-file-description mb10 pl5 pr5">Tiến độ giải quyết cho biết giai đoạn giải quyết hiện tại của đơn</p>
                    <ShowIf condition={!this.state.showTienDoGiaiQuyet}>
                      {
                        this.props.loaiDon == 'DON_KHIEU_NAI' &&
                        <DropDownKetQuaGiaiQuyetDon name='tienDoDoiThoai' disable={this.state.ketQuaXLDGiaiQuyet != '' ? true : false} className="col-25" selectedValue={this.state.tienDoDoiThoai} onChange={this.onChange.bind(this, 'tienDoDoiThoai')} loaiDon={this.props.loaiDonGiaTri} isTTXMLai={this.props.donViThamTraXacMinhInfo == null}/>
                      }
                      {
                        this.state.tienDoDoiThoai == 'KHONG_DOI_THOAI' &&
                        <DropDownMulipleUse disable={this.state.ketQuaXLDGiaiQuyet ? true : false} name="tienDoGiaiQuyet" confirm={true} label='' className="col-25" data={this.state.dataKetQuaGiaiQuyetDon} keyName='giaTri' valueName='ten' selectedValue={this.state.ketQuaXLDGiaiQuyet} onChange={this.onChange.bind(this, 'ketQuaXLDGiaiQuyet')}/>
                      }
                    </ShowIf>
                    <ShowIf condition={this.state.showTienDoGiaiQuyet}>
                      <Text className="col-25" label='' value={ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : ''}/>
                    </ShowIf>
                  </div>

                  <ShowIf condition={/*this.props.loaiDon == 'DON_TO_CAO' ||*/ this.props.loaiDon === 'DON_KHIEU_NAI'}>
                    <div className="col-100 no-gutter">
                      <ShowIfCheck label="Đối thoại" onChange={this.handleCheck.bind(this, 'doiThoai')} checked={this.state.doiThoai}>
                        <div className="col-100 no-gutter mt5 pb20">
                          <h2 className="title-12 mb15">Đối thoại</h2>
                          <div className="row pl10 pr10">
                            <DatePicker className="col-25" require bindValidator={this} channel="formTaoDon" label="Thời gian đối thoại" value={this.state.thoiGianDoiThoai} onChange={this.handleChangeDate.bind(this, 'thoiGianDoiThoai')} name="datepickerThoiGianDoiThoai"/>
                            <Input className="col-75" require bindValidator={this} channel="formTaoDon" label="Địa điểm" value={this.state.diaDiemDoiThoai} onChange={this.onChange.bind(this, 'diaDiemDoiThoai')} name="inputDiaDiem"/>
                            <TextArea className='col-100' require bindValidator={this} channel="formTaoDon" label='Nội dung, kết quả đối thoại' value={this.state.noiDungDoiThoai} onChange={this.onChange.bind(this, 'noiDungDoiThoai')}/>
                          </div>
                        </div>
                      </ShowIfCheck>
                    </div>
                    <div className="col-100 no-gutter pt5 pb15">
                      <span className="line-border"></span>
                    </div>
                  </ShowIf>
                </div>

                <div className="col-100 no-gutter">
                  <ShowIf condition={(this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')}>
                    <div className="col-100 no-gutter mb5 mt5">
                      <ShowIf condition={this.props.loaiDon === 'DON_KHIEU_NAI' && this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET'}><h2 className="title-12 mb15">Quyết định giải quyết khiếu nại</h2></ShowIf>
                      <ShowIf condition={this.props.loaiDon === 'DON_KHIEU_NAI' && this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI'}><h2 className="title-12 mb15">Quyết định đình chỉ</h2></ShowIf>
                      <ShowIf condition={this.props.loaiDon === 'DON_TO_CAO'}><h2 className="title-12 mb15">Quyết định giải quyết tố cáo</h2></ShowIf>
                      <ShowIf condition={this.props.loaiDon != 'DON_TO_CAO' && this.props.loaiDon != 'DON_KHIEU_NAI'}><h2 className="title-12 mb15">Văn bản giải quyết kiến nghị, phản ánh</h2></ShowIf>
                      <div className="row pl10 pr10">
                        <Input triggeOnBlur={true} name="inputSoVanBan" className="col-25" label="Số văn bản" bindValidator={this} channel="formTaoDon" require value={this.state.soVanBan} onChange={this.onChange.bind(this, 'soVanBan')} maxLength={255}/>
                        <DatePicker className="col-25" name="inputNgayBanHanh" label="Ngày ban hành" endDate={new Date()} bindValidator={this} channel="formTaoDon" require value={this.state.ngayBanHanh} onChange={this.handleChangeDate.bind(this, 'ngayBanHanh')}/>
                        <DropDownNguoiKy selected={this.state.nguoiBanHanh} onChange={this.onChange.bind(this, 'nguoiBanHanh')} />
                        {
                          this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' &&
                            <TextArea value={this.state.lyDoBanHanhQuyetDinhGiaiQuyet} className="areal-wrap col-100" label={`Nội dung ${this.state.gqText}`} placeholder="Nhập ..." onChange={this.onChange.bind(this, 'lyDoBanHanhQuyetDinhGiaiQuyet')} name="lyDoBanHanhQuyetDinhGiaiQuyet"/>
                        }
                        {
                          this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' &&
                            <TextArea value={this.state.lyDoBanHanhQuyetDinhDinhChi} bindValidator={this} channel="formTaoDon" require className="areal-wrap col-100" label="Lý do đình chỉ" placeholder="Nhập lý do" onChange={this.onChange.bind(this, 'lyDoBanHanhQuyetDinhDinhChi')} name="lyDoBanHanhQuyetDinhDinhChi" maxLength={1000}/>
                        }
                        <ShowIf condition={this.state.allowAttach}>
                          <div className="col-100">
                            <ContainerFileDinhKem quyetDinh={this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? true : false} loaiVanBanSuggest="QDGQ_TTT" ngayQuyetDinhSuggest={this.state.ngayBanHanh} soVanBanSuggest={this.state.soVanBan} onSave={this.state.onSave} loaiDon={this.state.loaiDon} phanLoaiQuyTrinh='QUYET_DINH_GIAI_QUYET' qDGQText='QDGQ_TTT' qDGQRequired={this.state.tTXMRequired} label="Danh sách văn bản xử lý" bindValidator={this} data={this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                          </div>
                        </ShowIf>
                      </div>
                      <div className="col-100 no-gutter pt10 pb20">
                        <span className="line-border"></span>
                      </div>
                      <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
                        <div className="row pl10 pr10">
                          <InputNumber className="col-25 mb0-18" label="Số vụ" value={this.state.soVuGiaiQuyetKhieuNai} onChange={this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai')}/>
                          <DropDownChonKetLuanNoiDungKhieuNai require bindValidator={this} channel="formTaoDon" loaiDon={this.state.loaiDon} label="Kết luận nội dung khiếu nại" className="col-25" selectedValue={this.state.ketLuanNoiDungKhieuNai} onChange={this.onChange.bind(this, 'ketLuanNoiDungKhieuNai')}/>
                          <Input className="col-25 mb0-18" label="Kết quả khác" name="ketQuaKhac" value={this.state.ketQuaGiaiQuyetKhac} onChange={this.onChange.bind(this, 'ketQuaGiaiQuyetKhac')}/>
                        </div>
                        <div className="row pl10 pr10">
                          <div className="col-50 no-gutter mb20">
                            <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                            <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải thu tiền (đ)" value={this.state.tienPhaiThuNhaNuocQDGQ} onChange={this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ')}/>
                            <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải thu đất (m2)" value={this.state.datPhaiThuNhaNuocQDGQ} onChange={this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ')}/>
                          </div>
                          <div className="col-50 no-gutter mb20">
                            <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                            <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải trả tiền (đ)" value={this.state.tienPhaiTraCongDanQDGQ} onChange={this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ')}/>
                            <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải trả đất (m2)" value={this.state.datPhaiTraCongDanQDGQ} onChange={this.onChange.bind(this, 'datPhaiTraCongDanQDGQ')}/>
                          </div>
                          <div className="col-100 no-gutter">
                            <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
                            <InputNumber className="col-25" label="Tổng số người" value={Number(this.state.tongSoNguoiXuLyHanhChinh)} onChange={this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh')}/>
                            <InputNumber className="col-25" label="Số người đã bị xử lý" value={Number(this.state.soNguoiDaBiXuLyHanhChinh)} onChange={this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh')}/>
                            <InputNumber className="col-25" label="Số người được trả lại quyền lợi" value={this.state.soNguoiDuocTraLaiQuyenLoi} onChange={this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi')}/>
                          </div>
                        </div>
                        <div className="col-100 no-gutter pt5 pb15">
                          <span className="line-border"></span>
                        </div>

                      </ShowIf>
                    </div>
                  </ShowIf>
                </div>
              </ShowIf>
              { this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET'  &&
                <div className="col-100 no-gutter">
                  <ShowIfCheck label="Theo dõi thực hiện" onChange={this.handleCheck.bind(this, 'theoDoiThucHien')} checked={this.state.theoDoiThucHien} >
                    <div className="col-100 no-gutter mt5 pb20">
                      <h2 className="title-12 mb15">Theo dõi thực hiện</h2>
                      <div className="row pl10 pr10 mb20">
                        <ShowIf condition={this.state.hinhThucTheoDoi === 'GIAO_CO_QUAN_KHAC_THEO_DOI'}>
                          <DropDownMulipleUse className="col-25 mb0-18" label="Cơ quan theo dõi" bindValidator={this} selectedValue={this.state.coQuanTheoDoi} onChange={this.onChange.bind(this, 'coQuanTheoDoi')} data={this.state.dataCoQuanTheoDoi} keyName='giaTri' valueName='ten'/>
                        </ShowIf>
                      </div>
                      <div className="row pl10 pr10 mb20">
                        <DropDownChonKetQuaThucHien className="col-25 mb0-18" bindValidator={this} require selectedValue={this.state.ketQuaThucHienTheoDoi} onChange={this.onChange.bind(this, 'ketQuaThucHienTheoDoi')}/>
                        <Input className="col-25 mb0-18" label="Kết quả thực hiện khác" value={this.state.ketQuaThucHienKhac} onChange={this.onChange.bind(this, 'ketQuaThucHienKhac')}/>
                      </div>
                      <div className="row pl10 pr10">
                        <div className="col-100 no-gutter mb20">
                          <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                          <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải thu tiền (đ)" value={this.state.tienPhaiThuNhaNuoc} onChange={this.onChange.bind(this, 'tienPhaiThuNhaNuoc')}/>
                          <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải thu đất (m2)" value={this.state.datPhaiThuNhaNuoc} onChange={this.onChange.bind(this, 'datPhaiThuNhaNuoc')}/>
                          <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã thu tiền (đ)" value={this.state.tienDaThuNhaNuoc} onChange={this.onChange.bind(this, 'tienDaThuNhaNuoc')}/>
                          <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã thu đất (m2)" value={this.state.datDaThuNhaNuoc} onChange={this.onChange.bind(this, 'datDaThuNhaNuoc')}/>
                        </div>
                        <div className="col-100 no-gutter">
                          <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                          <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải trả tiền (đ)" value={this.state.tienPhaiTraCongDan} onChange={this.onChange.bind(this, 'tienPhaiTraCongDan')}/>
                          <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải trả đất (m2)" value={this.state.datPhaiTraCongDan} onChange={this.onChange.bind(this, 'datPhaiTraCongDan')}/>
                          <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã trả tiền (đ)" value={this.state.tienDaTraCongDan} onChange={this.onChange.bind(this, 'tienDaTraCongDan')}/>
                          <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã trả đất (m2)" value={this.state.datDaTraCongDan} onChange={this.onChange.bind(this, 'datDaTraCongDan')}/>
                        </div>
                      </div>
                    </div>
                  </ShowIfCheck>
                  <div className="col-100 no-gutter pt5 pb15">
                    <span className="line-border"></span>
                  </div>
                </div>
              }


              <div className="col-100 no-gutter">
                <ShowIfCheck label="Chuyển cơ quan điều tra(Nếu có)" onChange={this.handleCheck.bind(this, 'giaoCoQuanDieuTra')} checked={this.state.giaoCoQuanDieuTra}>
                  <div className="col-100 no-gutter mt5">
                    <h2 className="title-12 mb15">Chuyển cơ quan điều tra(Nếu có)</h2>
                    <div className="row pl10 pr10">
                      <DropDownChonCoQuanDieuTra className="col-25" label="Tên cơ quan" bindValidator={this} require selectedValue={this.state.coQuanDieuTra} onChange={this.onChange.bind(this, 'coQuanDieuTra')}/>
                      <InputNumber className="col-25" label="Số vụ" value={this.state.soVuGiaoCoQuanDieuTra} onChange={this.onChange.bind(this, 'soVuGiaoCoQuanDieuTra')}/>
                      <InputNumber className="col-25" label="Số đối tượng" value={this.state.soDoiTuongGiaoCoQuanDieuTra} onChange={this.onChange.bind(this, 'soDoiTuongGiaoCoQuanDieuTra')} maxLength={255}/>
                    </div>
                    <ShowIf condition={this.state.allowAttachGiaoCoQuanDieuTra}>
                      <div className="col-100 no-gutter pb5">
                        <ContainerFileDinhKem onSave={this.state.onSave} phanLoaiQuyTrinh='GIAO_CO_QUAN_DIEU_TRA' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.taiLieuVanThuGiaoCoQuanDieuTra} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                      </div>
                    </ShowIf>
                  </div>
                  <div className="col-100 no-gutter pt5 pb15">
                    <span className="line-border"></span>
                  </div>
                  <div className="col-100 no-gutter">
                    <ShowIfCheck label="Khởi tố" onChange={this.handleCheck.bind(this, 'khoiTo')} checked={this.state.khoiTo}>
                      <div className="col-100 no-gutter mt5">
                        <h2 className="title-12 mb15">Khởi tố</h2>
                        <div className="row pl10 pr10">
                          <div className="col-50 no-gutter mb20">
                            <InputNumber className="col-50 mb0-18" label="Số vụ" value={this.state.soVuBiKhoiTo} onChange={this.onChange.bind(this, 'soVuBiKhoiTo')}/>
                            <InputNumber className="col-50 mb0-18" label="Số đối tượng" value={this.state.soDoiTuongBiKhoiTo} onChange={this.onChange.bind(this, 'soDoiTuongBiKhoiTo')} maxLength={255}/>
                          </div>
                        </div>
                      </div>
                    </ShowIfCheck>
                  </div>
                </ShowIfCheck>
              </div>


            </div>
          </ShowIf>
          <ShowIf condition={this.state.nextState === 'KET_THUC' && this.state.showFile}>
            <div className="col-100 pb5">
              <ContainerFileDinhKem phanLoaiQuyTrinh='' label="Danh sách văn bản xử lý" bindValidator={this} data={this.props.listTaiLieuVanThuGiaiQuyetDon} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} onSave={this.state.onSave}/>
            </div>
          </ShowIf>
        </div>
        <div className='col-100'>
          <div className='wrap-gqd-kqt'>
            <div className="box-bottom gqd-wrap col-100 mt20 pt30">
              <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
              <ShowIf condition={this.state.nextState === 'KET_THUC'}>
                <span className="wrap-link">
                  <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu tạm</span></Link>
                  <ShowIf condition={(this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' || this.state.tienDoDoiThoai === 'DOI_THOAI')}>
                    <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this, 'luuHoSo')}><span>Lưu hồ sơ</span></Link>
                  </ShowIf>
                  <ConfirmDialog open={this.state.openDialogLuuHoSo} onClose={this.closeDialog.bind(this)} onSuccess={this.onSuccess.bind(this, 'luuHoSo')} title="Xác nhận lưu hồ sơ" content="Bạn có muốn lưu hồ sơ này?"/>
                </span>
              </ShowIf>
            </div>
          </div>
        </div>
        <Dialog
        isOpen={this.state.open}
        onClose={this.closeDialogConfirm.bind(this)}
        title='Xác nhận'
        className="reception-dialog delete-dialog wrap-block"
        >
          <div className="pt-dialog-body">
            <p className="reception-dialog-text">{this.state.message}</p>
          </div>
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" onClick={this.closeDialogConfirm.bind(this)}><span>Không</span></Link>
            <Link className="btn-green" onClick={this.onSuccessDialogConfirm.bind(this)}><span>Đồng ý</span></Link>
          </div>
        </Dialog>
      </section>
    );
  }
}

GiaiQuyetDonCanBo.defaultProps = {
  validators: {},
  tenCoQuan: [],
  ketQuaGiaiQuyetDon: [],
  onSave: false
}


let bindStateToProps = state => {
  return {
    tenCoQuan: state.duLieuHeThong.donViTTXM,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  }
}

export default connect(bindStateToProps)(GiaiQuyetDonCanBo);



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/GiaiQuyetDonCanBo.jsx